module.exports = __webpack_public_path__ + "static/woman-as-9b99cf854a89259b233ecfe38f15d21d.jpg";